<template>
  <div>
    <p>
      <span class="cmr-miles-duration-text">
        Miles:
      </span>
      <span class="cmr-miles-duration">
        {{ distanceMiles() }}&nbsp;
      </span>
      <span class="cmr-miles-duration-text">
        |
        &nbsp;Dur:
      </span>
      <span class="cmr-miles-duration">
        {{ distanceHoursMinutes }}
      </span>
    </p>
  </div>
</template>

<script>
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

export default {
  name: "BookingTripETARoute",
  components: {},
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    bookingForm: Object,
  },
  data() {
    return {};
  },
  computed: {
    distanceHoursMinutes: function () {
      if (this.bookingForm.booking.route.time == null) {
        return "";
      }

      return this.minutesToHoursMinutesString(
        this.bookingForm.booking.route.time
      );
    },
  },
  methods: {
    distanceMiles: function () {
      if (this.bookingForm.booking.route.distance_in_miles == null) {
        return "";
      }

      return this.bookingForm.booking.route.distance_in_miles.toFixed(1) + "mi";
    },
    durationToHoursMinutesString: function (duration, minutesString) {
      return Overwatch.durationToHoursMinutesString(duration, minutesString);
    },
    minutesToHoursMinutesString: function (minutes) {
      var duration = moment.duration(minutes, "minutes");

      var hoursMinutesString = this.durationToHoursMinutesString(duration, "m");

      return hoursMinutesString;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
